import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import axios from "axios";
import { format } from "date-fns";
import { useReactToPrint } from "react-to-print";
import {
  FaFilter,
  FaColumns,
  FaCompress,
  FaExpand,
  FaLayerGroup,
} from "react-icons/fa";
import {
  FaAngleRight,
  FaChevronDown,
  FaChevronUp,
  FaChevronRight,
  FaChevronLeft,
} from "react-icons/fa6";
import { IoMdClose, IoIosArrowDown } from "react-icons/io";
import { MdOutlineSegment, MdOutlineFileDownload } from "react-icons/md";
import {
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@mui/material";

import ModifyColumns from "./Tools/ModifyColumns";
import { DateRangeSelector } from "./../styles/CustomDateRangePicker";
import "./OnBoardingAudit/NotoSans-Regular-normal";

import {
  DATEWISE_COLUMNS,
  DEVICE_COLUMNS,
  GROUP_COLUMNS,
  GROUP_DATEWISE_COLUMNS,
  INITIAL_COLUMNS,
  PATTERNWISE_COLUMNS,
} from "./Components/Location/LocationColumns";
import {
  apiRequestBodyBuilder,
  FilterComponent,
  formatSegmentData,
  getFilteredData,
  getPriorityColumnsFromStorage,
  getSortableValueGLOBAL,
  renderTableCell,
  renderTableTotal,
} from "./config/tableHelper";
import { RenderTable } from "./config/tableWrapper";
import { generatePDF, generateCSV } from "./Components/DownloadFuncs";

// Skeleton styled identically to PaidAdsPage TableSkeleton
function TableSkeleton() {
  return (
    <div className="w-full rounded-lg border border-gray-200 bg-white p-5 shadow-sm">
      {/* Header Bar */}
      <div className="flex items-center justify-between pb-4 border-b border-gray-100 animate-pulse">
        <div className="h-4 w-32 bg-gray-200 rounded" />
        <div className="flex items-center gap-8 sm:gap-12">
          <div className="h-4 w-16 bg-gray-200 rounded hidden sm:block" />
          <div className="h-4 w-16 bg-gray-200 rounded" />
          <div className="h-4 w-20 bg-gray-200 rounded" />
          <div className="h-4 w-24 bg-gray-200 rounded hidden md:block" />
        </div>
      </div>

      {/* Rows */}
      <div className="divide-y divide-gray-100 animate-pulse">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
          <div key={item} className="flex items-center justify-between py-4">
            <div className="flex items-center gap-3">
              <div
                className="h-4 bg-gray-200 rounded"
                style={{ width: `${140 + (item % 3) * 35}px` }}
              />
            </div>
            <div className="flex items-center gap-8 sm:gap-12">
              <div className="h-4 w-14 bg-gray-100 rounded hidden sm:block" />
              <div className="h-4 w-16 bg-gray-100 rounded" />
              <div className="h-4 w-16 bg-gray-100 rounded" />
              <div className="h-4 w-20 bg-gray-100 rounded hidden md:block" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const Locations3 = () => {
  const [showColumnsMenu, setShowColumnsMenu] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [groups, setGroups] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [tableVisible, setTableVisible] = useState(true);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState(INITIAL_COLUMNS);
  const [total, setTotal] = useState({});
  const [showTotal, setShowTotal] = useState(true);
  const [locationType, setLocationType] = useState("country");
  const [parentLocation, setParentLocation] = useState("");
  const [parentLocationType, setParentLocationType] = useState("none");
  const [random, setRandom] = useState(
    () => Math.floor(Math.random() * 100) + 1,
  );
  const [locationTypeArray, setLocationTypeArray] = useState([
    { id: 0, name: "country", priority: 0 },
    { id: 1, name: "state", priority: 1 },
    { id: 2, name: "city", priority: 2 },
  ]);
  const [narrowByArray, setNarrowByArray] = useState([
    { id: 0, locationType: null, locationParent: null },
  ]);
  const [filterArray, setFilterArray] = useState([]);
  const [currentGroupType, setCurrentGroupType] = useState("");
  const [selectDatewiseType, setSelectDatewiseType] = useState("year");
  const [currentSegment, setCurrentSegment] = useState("default");
  const [viewMode, setViewMode] = useState("locations");
  const [isGroupDropdownVisible, setGroupDropdownVisible] = useState(false);
  const [selectedGroupIds, SetSelectedGroupIds] = useState([]);
  const [showDatewiseType, setShowDatewiseType] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [narrowByDropDown, setNarrowByDropDown] = useState(false);
  const [segmentShow, setSegmentShow] = useState(false);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const showCheckBoxes = currentSegment === "default" && viewMode !== "groups";

  let today = new Date(),
    year = today.getFullYear(),
    month = today.getMonth();

  const [state, setState] = useState([
    { startDate: new Date(year, month, 1), endDate: today, key: "selection" },
  ]);

  const datePickerRef = useRef(null);
  const ColumnRef = useRef(null);
  const segmentRef = useRef(null);
  const groupRef = useRef(null);
  const exportRef = useRef(null);
  const downloadRef = useRef(null);

  const handleDownload = async (type) => {
    setShowDownloadMenu(false);
    setIsDownloading(true);
    try {
      const filename = `Location_Report_${format(new Date(), "yyyy-MM-dd")}.${type}`;
      const dateRangeStr =
        state[0].startDate === state[0].endDate
          ? "All time"
          : `${format(state[0].startDate, "MMM dd, yyyy")} - ${format(state[0].endDate, "MMM dd, yyyy")}`;

      // Delay slightly so UI spinner renders
      await new Promise((resolve) => setTimeout(resolve, 100));

      if (type === "pdf") {
        await generatePDF(
          filteredData,
          columns,
          dateRangeStr,
          filename,
          "Location report",
        );
      } else if (type === "csv") {
        await generateCSV(
          filteredData,
          columns,
          dateRangeStr,
          filename,
          "Location report",
        );
      }
    } catch (error) {
      console.error(`Failed to generate ${type.toUpperCase()}:`, error);
    } finally {
      setIsDownloading(false);
    }
  };

  const removeFilterFromArray = (idToRemove) => {
    setFilterArray((prev) => prev.filter((f) => f.id !== idToRemove));
  };

  function removeFromsetNarrowByArrowFunc() {
    if (narrowByArray.length <= 1) return;
    const newArray = narrowByArray.slice(0, -1);
    setNarrowByArray(newArray);
    const lastElement = newArray[newArray.length - 1];
    if (!lastElement || !lastElement.locationType) {
      setLocationType("country");
      setParentLocation("");
      setParentLocationType("none");
    } else {
      setLocationType(lastElement.locationType);
      setParentLocation(lastElement.locationParent);
      if (lastElement.locationType === "city") setParentLocationType("state");
      else if (lastElement.locationType === "state")
        setParentLocationType("country");
      else setParentLocationType("country");
    }
    setRandom(Math.floor(Math.random() * 100) + 1);
  }

  const fetchGroups = useCallback(async () => {
    try {
      let requestBody = buildApiRequestBody();
      const responseInfo = await axios.post(
        "https://api.confidanto.com/campaign-group2/group-info",
        requestBody,
      );

      const groupType = responseInfo.data;
      const typeForQuery =
        groupType?.type === "keyword"
          ? "keywords"
          : (groupType?.type ?? "campaign");
      const TYPEQUERY =
        typeForQuery?.charAt(0).toUpperCase() + typeForQuery?.slice(1);
      setCurrentGroupType(TYPEQUERY);
      requestBody.type = typeForQuery;

      const response = await axios.post(
        "https://api.confidanto.com/campaign-group/fetch-groups",
        requestBody,
      );
      setGroups(response.data.groups || []);
    } catch (err) {
      console.error(err);
    }
  }, []);

  const getCustomColumns = async () => {
    try {
      const requestBody = apiRequestBodyBuilder(null);

      const response = await axios.post(
        "https://api.confidanto.com/custom_columns/get-custom-columns",
        requestBody,
      );
      const temp = response.data.data.map((i) => ({
        id: i.id,
        title: i.custom_column,
        key: i.custom_column,
        visible: false,
        category: "Custom Columns",
        type: "number",
      }));
      setColumns((prevColumns) => {
        const prevColsFiltered = prevColumns.filter(
          (item) => item.category !== "Custom Columns",
        );
        const allColumns = [...prevColsFiltered, ...temp];

        const sorted = getPriorityColumnsFromStorage(allColumns);

        return sorted;
      });
    } catch (error) {
      setColumns((prevColumns) => {
        const sorted = getPriorityColumnsFromStorage(prevColumns);
        return sorted;
      });
      console.error("Error fetching custom columns:", error);
    }
  };

  function capitalizeFirstLetter(str) {
    return str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";
  }

  const handleSelectOptionChange = (event) => {
    setLocationType(event.target.value);
    setRandom(Math.floor(Math.random() * 100) + 1);
  };

  const toggleSegmentChange = (type) => {
    setFilterArray([]);
    setCurrentSegment(type);
    toggleDropDownTabs("Hide all");
    setCurrentPage(1);
    setRandom(Math.floor(Math.random() * 100) + 1);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        await fetchGroups();
        setCurrentPage(1);

        switch (currentSegment) {
          case "device":
            await fetchDeviceData();
            break;
          case "datewise":
            if (viewMode === "groups") {
              await fetchDatewiseGroupData();
            } else {
              await fetchDatewiseData();
            }
            break;
          case "search":
            await fetchPatternwiseData();
            break;
          case "default":
            if (viewMode === "groups") {
              await fetchGroupData();
            } else {
              await fetch_matched();
            }
            break;
          default:
            await fetch_matched();
            break;
        }

        await getCustomColumns();
      } catch (error) {
        console.error("An error occurred during data fetching:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [random, currentSegment, viewMode, selectDatewiseType]);

  const NarrowLocationSelectOption = () => {
    const currLocation = locationTypeArray.find(
      (item) => item.name === parentLocationType,
    );
    const currentPriority = currLocation ? currLocation.priority : -1;
    return (
      <FormControl fullWidth>
        <Select value={locationType} onChange={handleSelectOptionChange}>
          {locationTypeArray.map(
            (item) =>
              item.priority > currentPriority && (
                <MenuItem key={item.id} value={item.name}>
                  {capitalizeFirstLetter(item.name)}
                </MenuItem>
              ),
          )}
        </Select>
      </FormControl>
    );
  };

  const NarrowLocationDropDown = () => {
    const currLocation = locationTypeArray.find(
      (item) => item.name === locationType,
    );
    if (!currLocation || currLocation.priority >= 2) return null;
    return (
      <div className="absolute bg-white p-2 m-2 flex flex-col justify-center items-start z-40 w-32">
        {locationTypeArray.map(
          (item) =>
            item.priority > currLocation.priority && (
              <button
                key={item.id}
                className="p-2 w-full hover:bg-slate-50"
                onClick={() =>
                  ToggleLocationNarrowBy(item.name, parentLocation)
                }
              >
                <p>{capitalizeFirstLetter(item.name)}</p>
              </button>
            ),
        )}
      </div>
    );
  };

  const ToggleLocationNarrowBy = (locationTypeInner, parentLocation) => {
    setParentLocationType(locationType);
    setLocationType(locationTypeInner);

    const firstRowLocation =
      selectedRows[0]?.name || selectedRows[0]?.campaign_name;

    setParentLocation(firstRowLocation);
    setNarrowByArray((prev) => [
      ...prev,
      {
        id: prev.length,
        locationType: locationTypeInner,
        locationParent: firstRowLocation,
      },
    ]);
    setSelectAll(false);
    setSelectedRows([]);
    setNarrowByDropDown(false);
    setRandom(Math.floor(Math.random() * 100) + 1);
  };

  function sortObjectsArray(arr, key, order = "asc") {
    return [...arr].sort((a, b) => {
      const valA = getSortableValueGLOBAL(a, key);
      const valB = getSortableValueGLOBAL(b, key);

      if (valA === undefined || valB === undefined) return 0;
      if (typeof valA === "string")
        return order === "asc"
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      if (typeof valA === "number")
        return order === "asc" ? valA - valB : valB - valA;
      return 0;
    });
  }

  const buildApiRequestBody = (additionalParams = {}) => {
    let prevDates = {};
    if (state.length > 1) {
      prevDates = {
        previous_start_date: format(state[1].startDate, "yyyy-MM-dd"),
        previous_end_date: format(state[1].endDate, "yyyy-MM-dd"),
      };
    }
    const body = {
      email: localStorage.getItem("email"),
      ad_account_id: localStorage.getItem("ad_account_id"),

      customer_id: localStorage.getItem("customer_id"),
      project_id: localStorage.getItem("project_id"),
      start_date: format(state[0].startDate, "yyyy-MM-dd"),
      end_date: format(state[0].endDate, "yyyy-MM-dd"),
      filter_by: locationType,
      ...additionalParams,
      ...prevDates,
    };
    if (parentLocation && parentLocationType && parentLocationType !== "none") {
      body.parent = { name: parentLocation, type: parentLocationType };
    }
    return body;
  };

  const fetchDeviceData = async () => {
    setData([]);
    toggleDropDownTabs("Hide all");
    try {
      const res = await axios.post(
        "https://api.confidanto.com/locations/device",
        buildApiRequestBody(),
      );
      if (res.data) {
        setColumns(DEVICE_COLUMNS);
        setData(Array.isArray(res.data) ? res.data : []);
        setTotal({});
        setShowTotal(true);
      }
    } catch (err) {
      console.error("Error fetching device data:", err);
      setData([]);
    }
  };

  async function fetch_matched() {
    setData([]);
    try {
      const res = await axios.post(
        "https://api.confidanto.com/locations/matched-location-narrow-by",
        buildApiRequestBody(),
        { headers: { "Content-Type": "application/json" } },
      );
      if (Array.isArray(res.data)) {
        setColumns(INITIAL_COLUMNS);
        setData(res.data);
        setTotal({});
        setShowTotal(true);
      } else {
        setData([]);
      }
    } catch (err) {
      console.error("Error fetching matched locations:", err);
      setData([]);
    }
  }

  const toggleGroupSegment = () => {
    if (viewMode === "groups") {
      setViewMode("locations");
      toggleDropDownTabs("Hide all");
    } else {
      toggleDropDownTabs("Category");
    }
  };

  const handleGroupChange = (event) => SetSelectedGroupIds(event.target.value);
  const getSelectedGroupNames = (selectedIds) =>
    groups
      .filter((g) => selectedIds.includes(g.group_id))
      .map((g) => g.group_name)
      .join(", ");

  const fetchGroupData = async () => {
    const requestBody = buildApiRequestBody({ group_ids: selectedGroupIds });
    setData([]);
    try {
      const res = await axios.post(
        "https://api.confidanto.com/location-group/datewise-data",
        requestBody,
      );
      let newCols = GROUP_COLUMNS.map((col) => {
        if (col.key === "group_name") {
          col.title = `${currentGroupType} Group`;
        }
        return col;
      });
      setColumns(newCols);
      setData(res.data || []);
      setTotal({});
      setShowTotal(true);
    } catch (err) {
      console.error("Error fetching group-filtered locations:", err);
      setData([]);
    }
  };

  const fetchPatternwiseData = async () => {
    setData([]);
    try {
      const res = await axios.post(
        "https://api.confidanto.com/locations/network",
        buildApiRequestBody(),
      );
      if (res.data) {
        setData(res.data);
        setColumns(PATTERNWISE_COLUMNS);
      }
      setTotal({});
      setShowTotal(true);
    } catch (err) {
      console.error("Error fetching patternwise data:", err);
      setData([]);
    }
  };

  const fetchDatewiseData = async () => {
    setData([]);
    const requestBody = buildApiRequestBody({ group_by: selectDatewiseType });
    try {
      const res = await axios.post(
        "https://api.confidanto.com/locations/segment-data",
        requestBody,
      );
      const resultData = res.data;
      if (Array.isArray(resultData)) {
        let structuredData = resultData.map((item) => ({
          ...item,
          location:
            item.location?.state ||
            item.location?.city ||
            item.location?.country ||
            "",
        }));
        setData(formatSegmentData(structuredData, selectDatewiseType));

        let newColumns = DATEWISE_COLUMNS.map((item) => {
          if (["date", "week", "month", "segment"].includes(item.key)) {
            item.title = capitalizeFirstLetter(selectDatewiseType);
          }
          return item;
        });
        if (selectDatewiseType === "date") {
          newColumns = newColumns.map((item) =>
            item.key === "day_name" ? { ...item, visible: true } : item,
          );
        }
        setColumns(newColumns);
        setTotal({});
        setShowTotal(true);
      } else {
        setData([]);
      }
    } catch (err) {
      console.error("Error fetching datewise data:", err);
      setData([]);
    }
  };

  const fetchDatewiseGroupData = async () => {
    setData([]);
    const requestBody = buildApiRequestBody({
      group_by: selectDatewiseType,
      group_ids: selectedGroupIds,
    });
    try {
      const res = await axios.post(
        "https://api.confidanto.com/location-group/segment-data",
        requestBody,
      );
      const resultData = res.data;
      if (Array.isArray(resultData)) {
        let structuredData = resultData.map((item) => ({
          ...item,
          location:
            item.location?.state ||
            item.location?.city ||
            item.location?.country ||
            "",
        }));
        setData(formatSegmentData(structuredData, selectDatewiseType));

        let newColumns = GROUP_DATEWISE_COLUMNS.map((item) => {
          if (["date", "week", "month", "segment"].includes(item.key)) {
            item.title = capitalizeFirstLetter(selectDatewiseType);
          }
          return item;
        });
        if (selectDatewiseType === "date") {
          newColumns = newColumns.map((item) =>
            item.key === "day_name" ? { ...item, visible: true } : item,
          );
        }
        newColumns = newColumns.map((col) => {
          if (col.key === "group_name") {
            col.title = `${currentGroupType} Group`;
          }
          return col;
        });
        setColumns(newColumns);
        setTotal({});
        setShowTotal(true);
      } else {
        setData([]);
      }
    } catch (err) {
      console.error("Error fetching datewise group data:", err);
      setData([]);
    }
  };

  const toggleDatewiseType = (type) => {
    setSelectDatewiseType(type);
    toggleSegmentChange("datewise");
  };

  const resetLocations = () => {
    setLocationType("country");
    setCurrentPage(1);
    setParentLocation("");
    setParentLocationType("none");
    setCurrentSegment("default");
    setViewMode("locations");
    setFilterArray([]);
    setRandom(Math.floor(Math.random() * 100) + 1);
    setNarrowByArray([{ id: 0, locationType: null, locationParent: null }]);
    toggleDropDownTabs("Hide all");
  };

  const filteredResult = useMemo(() => {
    return getFilteredData(Array.isArray(data) ? data : [], filterArray);
  }, [data, filterArray]);

  const filteredData = useMemo(() => {
    if (!sortConfig.key) return filteredResult;
    return sortObjectsArray(
      filteredResult,
      sortConfig.key,
      sortConfig.direction,
    );
  }, [filteredResult, sortConfig]);

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    setSelectedRows(!selectAll ? [...filteredData] : []);
  };

  const handleCheckboxChange = (item) => {
    const isSelected = selectedRows.some((row) => row === item);
    setSelectedRows(
      isSelected
        ? selectedRows.filter((row) => row !== item)
        : [...selectedRows, item],
    );
  };

  useEffect(() => {
    if (!showCheckBoxes) {
      setSelectedRows([]);
      setSelectAll(false);
    }
  }, [showCheckBoxes]);

  const toggleFullScreen = () => setIsFullScreen(!isFullScreen);

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc")
      direction = "desc";
    setSortConfig({ key, direction });
  };

  const toggleDropDownTabs = (type) => {
    setShowDatePicker(type === "Calendar" ? !showDatePicker : false);
    setSegmentShow(type === "Segment" ? !segmentShow : false);
    setGroupDropdownVisible(
      type === "Category" ? !isGroupDropdownVisible : false,
    );
    setShowColumnsMenu(type === "Columns" ? !showColumnsMenu : false);
    setShowDownloadMenu(type === "Download" ? !showDownloadMenu : false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      const isClickInsideMuiMenu = event.target.closest(
        ".groupwise-select-menu",
      );
      if (
        groupRef.current &&
        !groupRef.current.contains(event.target) &&
        !isClickInsideMuiMenu
      )
        setGroupDropdownVisible(false);
      if (
        datePickerRef.current &&
        !datePickerRef.current.contains(event.target)
      )
        setShowDatePicker(false);
      if (ColumnRef.current && !ColumnRef.current.contains(event.target))
        setShowColumnsMenu(false);
      if (segmentRef.current && !segmentRef.current.contains(event.target))
        setSegmentShow(false);
      if (downloadRef.current && !downloadRef.current.contains(event.target))
        setShowDownloadMenu(false);
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const visibleColumnsCount =
    columns.filter((c) => c.visible).length + (showCheckBoxes ? 1 : 0);

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };
  const handlePageChange = (newPage) => setCurrentPage(newPage);

  useEffect(() => {
    setCurrentPage(1);
  }, [rowsPerPage, sortConfig, filterArray]);

  const isLockedColumn = (col) => col.isLocked || col.locked || col.sticky;

  return (
    <div ref={exportRef}>
      <div
        className={`flex h-screen bg-white ${
          isFullScreen
            ? "fixed top-0 left-0 w-full h-full z-50 overflow-x-scroll"
            : ""
        }`}
      >
        <main className="flex flex-col flex-1 w-0  overflow-auto no-scrollbar p-6">
          <div
            className={`transition-opacity duration-300 ${loading ? "pointer-events-none opacity-50" : ""}`}
          >
            <DateRangeSelector
              state={state}
              setState={setState}
              setRandom={setRandom}
              showDatePicker={showDatePicker}
              toggleDropDownTabs={toggleDropDownTabs}
              datePickerRef={datePickerRef}
              Page="Locations"
            />
          </div>
          {selectedRows.length >= 1 ? (
            <div
              className={`w-full flex items-center justify-between p-4 space-x-2 bg-gray-50 text-lg mb-4 rounded-md transition-opacity duration-300 ${loading ? "pointer-events-none opacity-50" : ""}`}
            >
              <div className="flex items-center space-x-4 text-[#283593]">
                <h2>{selectedRows.length} Selected</h2>
                <div className="relative">
                  <button
                    disabled={loading}
                    onClick={() => setNarrowByDropDown(!narrowByDropDown)}
                    className={`flex items-center ${loading ? "cursor-not-allowed opacity-50" : ""}`}
                  >
                    <h2>Narrow By</h2>
                    <IoIosArrowDown className="ml-2" />
                  </button>
                  {narrowByDropDown && <NarrowLocationDropDown />}
                </div>
              </div>
              <button
                disabled={loading}
                className={`p-1 rounded-sm ${loading ? "cursor-not-allowed opacity-50" : "hover:text-white hover:bg-red-500"}`}
                onClick={() => {
                  setSelectedRows([]);
                  setSelectAll(false);
                }}
              >
                <IoMdClose className="text-2xl" />
              </button>
            </div>
          ) : (
            <div className="flex justify-between items-center mb-4">
              <div
                className={`transition-opacity duration-300 ${loading ? "pointer-events-none opacity-50" : ""}`}
              >
                <FilterComponent
                  columns={columns}
                  data={data}
                  filterArray={filterArray}
                  setFilterArray={setFilterArray}
                  segmentType={selectDatewiseType}
                />
              </div>
              <div className="flex space-x-2">
                <div className="relative" ref={segmentRef}>
                  <button
                    disabled={loading}
                    className={`px-4 py-2 min-w-[80px] rounded flex flex-col justify-center items-center gap-1 transition-all ${
                      currentSegment !== "default"
                        ? "bg-blue-100 text-blue-600"
                        : "bg-transparent text-gray-600"
                    } ${loading ? "opacity-50 cursor-not-allowed" : "hover:bg-slate-100"}`}
                    onClick={() => toggleDropDownTabs("Segment")}
                  >
                    <MdOutlineSegment className="text-md" />
                    <span className="text-md">Segment</span>
                  </button>
                  {segmentShow && (
                    <div className="absolute right-0 z-40 w-40 bg-white shadow-lg rounded-md mt-2 p-2 border">
                      <button
                        className="w-full text-left hover:bg-slate-50 p-2 rounded-sm"
                        onClick={resetLocations}
                      >
                        Reset
                      </button>
                      <div className="border-t my-1 -mx-2"></div>
                      <button
                        className={`w-full text-left p-2 rounded-sm ${
                          currentSegment === "device"
                            ? "bg-blue-100 text-blue-600"
                            : "hover:bg-slate-50"
                        }`}
                        onClick={() => toggleSegmentChange("device")}
                      >
                        Device
                      </button>
                      <button
                        className={`w-full text-left p-2 rounded-sm ${
                          currentSegment === "search"
                            ? "bg-blue-100 text-blue-600"
                            : "hover:bg-slate-50"
                        }`}
                        onClick={() => toggleSegmentChange("search")}
                      >
                        Search
                      </button>
                      <div className="relative w-full cursor-pointer">
                        <div
                          className="w-full text-left hover:bg-slate-50 h-10 p-2 rounded-sm flex justify-between items-center"
                          onClick={() => setShowDatewiseType(!showDatewiseType)}
                        >
                          <h2>Date</h2>
                          <IoIosArrowDown
                            className={`transition-transform ${
                              showDatewiseType ? "rotate-180" : ""
                            }`}
                          />
                        </div>
                        {showDatewiseType && (
                          <div className="pl-3 mt-0.5 flex flex-col space-y-1">
                            <button
                              className={`w-full text-left p-2 rounded-sm ${
                                currentSegment === "datewise" &&
                                selectDatewiseType === "date"
                                  ? "bg-blue-100 text-blue-600"
                                  : "hover:bg-slate-50"
                              }`}
                              onClick={() => toggleDatewiseType("date")}
                            >
                              Date
                            </button>
                            <button
                              className={`w-full text-left p-2 rounded-sm ${
                                currentSegment === "datewise" &&
                                selectDatewiseType === "week"
                                  ? "bg-blue-100 text-blue-600"
                                  : "hover:bg-slate-50"
                              }`}
                              onClick={() => toggleDatewiseType("week")}
                            >
                              Week
                            </button>
                            <button
                              className={`w-full text-left p-2 rounded-sm ${
                                currentSegment === "datewise" &&
                                selectDatewiseType === "month"
                                  ? "bg-blue-100 text-blue-600"
                                  : "hover:bg-slate-50"
                              }`}
                              onClick={() => toggleDatewiseType("month")}
                            >
                              Month
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div className="relative" ref={groupRef}>
                  <button
                    disabled={loading}
                    className={`px-4 py-2 min-w-[80px] rounded flex flex-col justify-center items-center gap-1 transition-all ${
                      loading
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-slate-100"
                    } bg-transparent text-gray-600`}
                    onClick={toggleGroupSegment}
                  >
                    <FaLayerGroup className="text-md" />
                    <span className="text-md">
                      {viewMode === "groups" ? "Location" : "Groups"}
                    </span>
                  </button>
                  {isGroupDropdownVisible && (
                    <div className="absolute right-0 bg-white shadow-md rounded p-4 mt-2 z-40 border w-64 space-y-2">
                      {groups && groups.length > 0 ? (
                        <>
                          <FormControl fullWidth>
                            <InputLabel>{`${currentGroupType} Group`}</InputLabel>
                            <Select
                              multiple
                              value={selectedGroupIds}
                              onChange={handleGroupChange}
                              input={
                                <OutlinedInput
                                  label={`${currentGroupType} Group`}
                                />
                              }
                              renderValue={getSelectedGroupNames}
                              MenuProps={{
                                className: "groupwise-select-menu",
                              }}
                            >
                              {groups.map((data) => (
                                <MenuItem
                                  key={data.group_id}
                                  value={data.group_id}
                                >
                                  <Checkbox
                                    checked={selectedGroupIds.includes(
                                      data.group_id,
                                    )}
                                  />
                                  <ListItemText primary={data.group_name} />
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <Button
                            variant="contained"
                            color="primary"
                            disabled={!selectedGroupIds?.length}
                            onClick={() => {
                              setViewMode("groups");
                              setCurrentSegment("default");
                              toggleDropDownTabs("Hide all");
                            }}
                            className="mt-2"
                          >
                            Apply
                          </Button>
                        </>
                      ) : (
                        <div className="flex flex-col items-center justify-center p-6 text-center">
                          <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100">
                            <FaLayerGroup className="text-gray-400 text-lg" />
                          </div>

                          <p className="text-sm font-medium text-gray-700">
                            No groups available
                          </p>

                          <p className="mt-1 text-xs text-gray-500 leading-relaxed">
                            You don’t have any groups created yet. Please create
                            a group to manage and apply group-based ads.
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div
                  className={`relative transition-opacity duration-300 ${loading ? "pointer-events-none opacity-50" : ""}`}
                  ref={downloadRef}
                >
                  <button
                    disabled={loading || isDownloading}
                    className={`px-4 py-2 min-w-[80px] rounded flex flex-col justify-center items-center gap-1 transition-all ${
                      loading || isDownloading
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-slate-100"
                    } ${showDownloadMenu ? "bg-blue-100 text-blue-600" : "bg-transparent text-gray-600"}`}
                    onClick={() => toggleDropDownTabs("Download")}
                  >
                    {isDownloading ? (
                      <svg
                        className="animate-spin h-5 w-5"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                    ) : (
                      <MdOutlineFileDownload className="text-md" />
                    )}
                    <span className="text-md">
                      {isDownloading ? "Downloading" : "Download"}
                    </span>
                  </button>
                  {showDownloadMenu && (
                    <div className="absolute right-0 z-40 w-36 bg-white shadow-lg rounded-lg mt-2 p-2 border">
                      <div
                        className="p-2 hover:bg-gray-100 cursor-pointer rounded flex items-center justify-between text-gray-700"
                        onClick={() => handleDownload("pdf")}
                      >
                        .PDF
                      </div>
                      <div
                        className="p-2 hover:bg-gray-100 cursor-pointer rounded flex items-center justify-between text-gray-700"
                        onClick={() => handleDownload("csv")}
                      >
                        .CSV
                      </div>
                    </div>
                  )}
                </div>

                <button
                  disabled={loading}
                  className={`px-4 py-2 min-w-[80px] rounded flex flex-col justify-center items-center gap-1 transition-all ${
                    isFullScreen
                      ? "bg-blue-100 text-blue-600"
                      : "bg-transparent text-gray-600"
                  } ${loading ? "opacity-50 cursor-not-allowed" : "hover:bg-slate-100"}`}
                  onClick={toggleFullScreen}
                >
                  {isFullScreen ? (
                    <FaCompress className="text-md" />
                  ) : (
                    <FaExpand className="text-md" />
                  )}
                  <span className="text-md">
                    {isFullScreen ? "Collapse" : "Expand"}
                  </span>
                </button>
                <div className="relative" ref={ColumnRef}>
                  <button
                    disabled={loading}
                    className={`px-4 py-2 min-w-[80px] rounded flex flex-col justify-center items-center gap-1 transition-all ${
                      loading
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-slate-100"
                    } bg-transparent text-gray-600`}
                    onClick={() => toggleDropDownTabs("Columns")}
                  >
                    <FaColumns className="text-md" />
                    <span className="text-md">Columns</span>
                  </button>
                  {showColumnsMenu && (
                    <ModifyColumns
                      columns={columns}
                      setColumns={setColumns}
                      setTableVisible={setTableVisible}
                      setTotalShow={setShowTotal}
                      setTotal={setTotal}
                      setShowColumnsMenu={setShowColumnsMenu}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
          {tableVisible && (
            <>
              <div className="w-full">
                <div className="narrowByArray flex flex-col justify-center items-start p-2 text-xl">
                  <div className="flex flex-row justify-start items-center">
                    {narrowByArray.length > 1 &&
                      narrowByArray.map((item, index) => {
                        if (narrowByArray.length - 1 === index) return null;
                        return (
                          <React.Fragment key={index}>
                            <div className="flex flex-row space-x-1 justify-center items-center">
                              <p className="text-blue-500 text-lg">
                                {item.locationParent
                                  ? item.locationParent
                                  : "Location"}
                              </p>
                              <span>
                                <FaAngleRight />
                              </span>
                            </div>
                          </React.Fragment>
                        );
                      })}
                  </div>
                  {narrowByArray[narrowByArray.length - 1].locationParent !=
                    null && (
                    <div className="flex flex-col justify-center items-start w-52">
                      <div className="flex flex-row justify-between items-center w-full">
                        <p className="text-2xl">
                          {
                            narrowByArray[narrowByArray.length - 1]
                              .locationParent
                          }
                        </p>
                        <button
                          onClick={removeFromsetNarrowByArrowFunc}
                          className="font-semibold text-3xl"
                        >
                          <IoMdClose />
                        </button>
                      </div>
                      <div className="w-full">
                        <NarrowLocationSelectOption />
                      </div>
                    </div>
                  )}
                </div>
                {filterArray.length > 0 && (
                  <div className="w-full flex flex-row space-x-4 items-center p-2 relative">
                    <div className="flex flex-row w-11/12 overflow-auto scroll-container">
                      {filterArray.map((item) => (
                        <div
                          key={item.id}
                          className="flex flex-row items-center justify-between p-2 border border-black rounded-lg min-w-fit mx-1"
                        >
                          <h2 className="mr-2">
                            {item.title} {item.sign}{" "}
                            {Array.isArray(item.value)
                              ? item.value.join(", ")
                              : item.value}
                          </h2>
                          <button
                            onClick={() => removeFilterFromArray(item.id)}
                          >
                            <IoMdClose />
                          </button>
                        </div>
                      ))}
                    </div>
                    <div className="clearfilter flex item-center justify-center absolute right-5 text-2xl hover:bg-red-500 hover:text-white">
                      <button onClick={() => setFilterArray([])}>
                        <IoMdClose className="ml-5" />
                      </button>
                    </div>
                  </div>
                )}
                <div className="overflow-x-auto w-full">
                  {loading ? (
                    <TableSkeleton />
                  ) : filteredData.length > 0 ? (
                    <RenderTable
                      data={filteredData}
                      currentPage={currentPage}
                      rowsPerPage={rowsPerPage}
                      columns={columns}
                      variant="performance"
                      enableExpandCollapse={state.length > 1}
                      showCheckBoxes={showCheckBoxes}
                      selectedRows={selectedRows}
                      onSelectRow={(item) => handleCheckboxChange(item)}
                      onSelectAll={handleSelectAll}
                    />
                  ) : (
                    <div className="flex justify-center items-center h-40 mt-8 text-gray-600">
                      No data found
                    </div>
                  )}
                </div>
              </div>
              {!loading && filteredData.length > 0 && (
                <div className="flex justify-end items-center mt-4 font-roboto p-3 rounded-lg">
                  <div className="flex items-center space-x-2 mr-4">
                    <label className="text-gray-700">Rows per page:</label>
                    <select
                      value={rowsPerPage}
                      onChange={handleRowsPerPageChange}
                      className="border border-gray-300 rounded px-2 py-1"
                    >
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="15">15</option>
                    </select>
                  </div>
                  <div className="flex items-center space-x-3">
                    <button
                      disabled={currentPage === 1}
                      onClick={() => handlePageChange(currentPage - 1)}
                      className="px-1 py-1 rounded disabled:cursor-not-allowed hover:bg-gray-100"
                    >
                      <FaChevronLeft />
                    </button>
                    <span>
                      Page {currentPage} of {totalPages}
                    </span>
                    <button
                      disabled={currentPage === totalPages}
                      onClick={() => handlePageChange(currentPage + 1)}
                      className="px-1 py-1 font-bold rounded disabled:cursor-not-allowed hover:bg-gray-100"
                    >
                      <FaChevronRight />
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </main>
      </div>
    </div>
  );
};

export default Locations3;
